import React from 'react'

export default function InstallmentTab({ data }) {
    return (
        <div>
            {data.map((item, index) => {
                return (
                    <div key={index} className='mb-4'>
                        <div className="detail-bold-text" style={{ fontWeight: '600', color: '#2C465C' }}>Cicilan ke-{item.periodNumber}</div>
                        <div className="detail-bold-text">
                            <div className="row detail-row">
                                <div className="col-4">Periode</div>
                                <div className="col-md-auto">:</div>
                                <div className="col">{item.periode}</div>
                            </div>
                            <div className="row detail-row">
                                <div className="col-4">Tagihan Pokok</div>
                                <div className="col-md-auto">:</div>
                                <div className="col">{item.installmentAmount}</div>
                            </div>
                            {
                                item.interestType.includes('behind') &&
                                <>
                                    <div className="row detail-row">
                                        <div className="col-4">Biaya Sewa Modal</div>
                                        <div className="col-md-auto">:</div>
                                        <div className="col">{item.capitalLoan}</div>
                                    </div>
                                    {item.interestType === 'behind' && <>
                                        <div className="row detail-row">
                                            <div className="col-4">Biaya Administrasi</div>
                                            <div className="col-md-auto">:</div>
                                            <div className="col">{item.feeAdmin}</div>
                                        </div>
                                        <div className="row detail-row">
                                            <div className="col-4">Biaya Simpan & Asuransi</div>
                                            <div className="col-md-auto">:</div>
                                            <div className="col">{item.feeSavingInsurance}</div>
                                        </div>
                                    </>}
                                </>
                            }
                            <div className="row detail-row">
                                <div className="col-4">Denda Harian</div>
                                <div className="col-md-auto">:</div>
                                <div className="col">{item.lateDays}</div>
                            </div>
                            <div className="row detail-row">
                                <div className="col-4">Biaya Keterlambatan</div>
                                <div className="col-md-auto">:</div>
                                <div className="col">{item.latePeriod}</div>
                            </div>
                            <div className="row detail-row">
                                <div className="col-4">Status</div>
                                <div className="col-md-auto">:</div>
                                <div className="col" style={{ color: item.status?.color }}>{item.status?.label}</div>
                            </div>
                        </div>
                    </div>
                )
            })
            }
        </div>
    )
}
